import { variantProvider } from '@/app'
import { Text, useHurdle, View } from '@/components'

export function DictError() {
  const { dictError } = useHurdle()

  if (!dictError) return null

  return (
    <View style={styles.dictError}>
      <Text variants={['h4', 'color:neutral1']} text={dictError} />
    </View>
  )
}

const styles = variantProvider.createComponentStyle(
  theme => ({
    dictError: {
      backgroundColor: theme.colors.lavender3,
      ...theme.spacing.padding(0.25),
      borderRadius: 6,
      ...theme.presets.center,
      ...theme.presets.fullWidth,
      ...theme.spacing.marginTop(1),
      maxWidth: 430,
    },
  }),
  true,
)
